

/// <reference path="Asset.ts" />

// Generated class LocationAsset_ManagedObject

class LocationAsset_ManagedObject extends Asset
{

    // Property: resourceName
    set resourceName(value:string) {
        this.setValueForKey(value, 'resourceName');
    }
    get resourceName():string {
        return this.valueForKey('resourceName');
    }
    set resourceNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'resourceName');
    }
    get resourceNamePrimitiveValue():string {
        return this.primitiveValueForKey('resourceName');
    }
    // Relationship: location
    set location(value:Location) {
        this.setValueForKey(value, 'location');
    }
    get location():Location {
        return this.valueForKey('location') as Location;
    }
}
